import {h} from 'preact';

export function AddAssociatedUsersFail({usersNum}) {
	return (
	<div className="eds-c-status-message eds-c-status-messag--error">
		<div className="eds-c-status-message__content-icon">
			<svg  aria-hidden="true" width="16" height="16"
				 className="eds-c-status-message__icon">
				<use href="/static/img/svg-sprite.svg#error"/>
			</svg>
		</div>
		<div className="eds-c-status-message__text">
			<span>{(usersNum > 1 ? 'These emails' : 'This email')} cannot be invited right now. Sending invitations should work again in a few minutes.</span>
		</div>
	</div>
)
	;
}

export default AddAssociatedUsersFail;
